export default __webpack_public_path__ + "static/media/TOEFLTonic.23fbdd044389306c20f011c9b0f1a0f9.webp";